<label
  [class.has-border]="border"
  [class.is-disabled]="disabled"
  [class.is-checked]="value"
>
  <span class="checkbox-icon"></span>
  <input
    type="checkbox"
    (change)="toggleCheck($event)"
    [name]="name"
    [value]="value"
    [attr.checked]="value ? 'checked' : null"
    [attr.disabled]="disabled ? 'disabled' : null"
  />
  <span class="checkbox-details">
    <span class="label" [innerHTML]="label"></span>
    <span
      *ngIf="description"
      class="description"
      [innerHTML]="description"
    ></span>
    <ng-content select="[description]"></ng-content>
    <span class="additional-content" *ngIf="selectedContentTemplate && value">
      <ng-container *ngTemplateOutlet="selectedContentTemplate"></ng-container>
    </span>
  </span>
</label>
